import { NavLink, Outlet } from "react-router-dom";
import { GameweekProvider } from "../data/GameweekContext";
import { YourTeamCard } from "../ui/YourTeamCard";
import "./AppShell.css";

export const NAV_ITEMS = [
	{ to: "/matchups", label: "Matchups", icon: "ri-sword-line" },
	{ to: "/fixtures", label: "Fixtures", icon: "ri-football-line" },
	{ to: "/table", label: "League", icon: "ri-list-ordered-2" },
];

const linkClass = (base: string) =>
	({ isActive }: { isActive: boolean }) =>
		isActive ? `${base} active` : base;

export const AppShell = () => (
	<div className="shell">
		<aside className="sidebar">
			<div>
				<div className="eyebrow">Bullen·Stats</div>
				<div className="sidebar-title">The Bullen</div>
			</div>
			<nav className="sidebar-nav" aria-label="Primary">
				{NAV_ITEMS.map((item) => (
					<NavLink key={item.to} to={item.to} className={linkClass("sidebar-link")}>
						{item.label === "League" ? "League Table" : item.label}
					</NavLink>
				))}
				<NavLink to="/settings" className={linkClass("sidebar-link")}>
					Settings
				</NavLink>
			</nav>
			<div className="sidebar-footer">
				<YourTeamCard />
			</div>
		</aside>

		<main className="shell-main">
			<GameweekProvider>
				<Outlet />
			</GameweekProvider>
		</main>

		<nav className="tabbar" aria-label="Primary">
			{NAV_ITEMS.map((item) => (
				<NavLink key={item.to} to={item.to} className={linkClass("tabbar-link")}>
					{item.label}
				</NavLink>
			))}
		</nav>
	</div>
);
